import { onMounted, type Ref } from 'vue';

import { AnimateGroupReveal } from '@sg-core/resources/assets/js/animations';

export function useColumnReveal(rootRef: Ref<HTMLElement | null>): void {
  onMounted(() => {
    new AnimateGroupReveal({
      parentElement: rootRef.value ?? undefined,
      childrenSelector: '.phxsg-collections-block-desktop__image',
      delay: 0.1,
      start: 'top 80%',
    });
  });
}
